import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=1b42ec84"
import script from "./CustomerView.vue?vue&type=script&lang=ts"
export * from "./CustomerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports